<template>
  <div class="slideBox users-and-fans" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Fans
      </h1>
    </div>

    <div class="total-value users-and-fans-total">
      <div class="headlineBlock">
        <h2>Fans auf <div class="svg people-group-cheer"></div> Facebook</h2>
      </div>
      <div class="big value">
        <i-count-up
          :start="0"
          :end="totalValueEnd"
          :decimals="0"
          :duration="countDuration"
          :options="options"
        ></i-count-up>
      </div>
    </div>

    <div class="layoutWrapper">
      <div class="layoutBox box2">
        <div class="headlineBlock">
          <h2>Geschlechtsverteilung Fans</h2>
        </div>
        <pie-chart class="pieChart" v-if="dataGender" :data="dataGender" data-unit="%" :height="180"></pie-chart>
      </div>

      <div class="layoutBox box2">
        <div class="headlineBlock">
          <h2>Altersstruktur Fans</h2>
        </div>
        <bar-chart class="barChart" v-if="dataUserAge" data-unit="%" :data="dataUserAge" :height="180"></bar-chart>
      </div>
    </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import _ from 'lodash'
import PieChart from '@/components/charts/pie-chart'
import BarChart from '@/components/charts/bar-chart'

export default {
  name: 'users-and-fans',
  components: {
    ICountUp,
    PieChart,
    BarChart
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      dataGender: null,
      dataUserAge: null,
      chartColor: '#2d76bf',
      pieChartColors: [
        '#c21192',
        '#266797',
        '#ccc'
      ],
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    }
  },
  mounted () {
    const self = this
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_users_and_fans'
    const urlPart2 = theme + '-' + source + '_users_reached'
    const currentSlide = this.$store.state.allSlides[this.$route.query.id]

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor
    }
    if (currentSlide.pieChartColors) {
      this.pieChartColors = currentSlide.pieChartColors
    }

    /* total value */
    const totalValueURL = urlPart
    self.axios.get(totalValueURL).then((response) => {
      self.totalValueEnd = parseInt(_.head(response.data.results).Totals)
    })

    /* pie chart data */
    const pieChartDataURL = urlPart + '_by_age'
    self.axios.get(pieChartDataURL).then((response) => {
      self.fillDataPie(response.data.results)
    })

    /* bar chart data */
    const barChartDataURL = urlPart2 + '_user_age-last_7_days'
    self.axios.get(barChartDataURL).then((response) => {
      self.fillDataBar(response.data.results)
    })
  },
  methods: {
    fillDataPie (data) {
      const groups = []
      const percents = []

      /* fill arrays */
      _.each(data, (entry) => {
        groups.push(entry.gender)
        percents.push(parseFloat(entry.percent))
      })

      /* paid likes */
      this.dataGender = {
        labels: groups,
        datasets: [
          {
            backgroundColor: this.pieChartColors,
            borderWidth: 0,
            data: percents
          }
        ]
      }
    },

    fillDataBar (data) {
      const groups = []
      const percents = []

      /* fill arrays */
      _.each(data, (entry) => {
        groups.push(entry.group)
        percents.push(parseFloat(entry.percent))
      })

      /* paid likes */
      this.dataUserAge = {
        labels: groups,
        datasets: [
          {
            label: 'Altersstruktur',
            backgroundColor: this.chartColor,
            data: percents
          }
        ]
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/users-and-fans.vue